import { DialogContext } from "@/providers/dialogProvider/dialogContext";
import { useContext } from "react";

export const useDialog = () => {
  const context = useContext(DialogContext);
  if (!context) {
    throw new Error("useDialogContext must be used within a DialogProvider");
  }
  return context;
};
